import React, { useState, useEffect } from "react";
import { useInvoiceContext, useControlContext, usePagSeguroContext } from "../context";
import { Container, Row, Col, Card } from "react-bootstrap";
import { API_BASE_URL } from "../config";
import {
  Header,
  FormCNP,
  FormCustomer,
  FormEmail,
  ProgressViewer,
  Cart,
  Total,
  FormPhone,
  FormPaymentMethod,
  Footer,
  CardUpSell,
} from "../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faEnvelopeCircleCheck,
  faExclamationTriangle,
  faIdCard,
  faMoneyBill1Wave,
} from "@fortawesome/free-solid-svg-icons";
import { CardMenu } from "../components";

const CustomerRegister = (props) => {
  const { activeStepOne } = useControlContext();

  return (
    <CardMenu
      active={activeStepOne}
      title="Identificação & Registro"
      icon={faIdCard}
      badge="1º"
    >
      <FormCNP />
      <FormCustomer />
    </CardMenu>
  );
};

const CustomerContactAndPayMode = (props) => {
  const {
    activeStepTwo,
    activeStepThree,
    activeFormEmail,
    activeFormPhone,
    activeFormPaymentMethod,
    setActiveFormEmail,
    setActiveFormPhone,
    setActiveFormPaymentMethod,
  } = useControlContext();

  return (
    <CardMenu
      active={activeStepTwo}
      title="Entrega & Forma de Pagamento"
      icon={faEnvelopeCircleCheck}
      badge="2º"
    >
      <p
        className="text-muted"
        style={{
          fontSize: "0.8em",
          marginTop: "0.5em",
          display: activeStepTwo || activeStepThree ? "none" : "block",
        }}
      >
        <FontAwesomeIcon icon={faBan} /> Primeiro informe um cliente
      </p>

      <FormEmail
        active={
          (activeStepTwo && activeFormEmail) ||
          (activeStepThree && activeFormEmail)
        }
        handleNext={() => {
          setActiveFormEmail(false);
          setActiveFormPhone(true);
        }}
      />

      <FormPhone
        active={activeFormPhone}
        handleNext={() => {
          // setActiveFormPhone(false);
          setActiveFormPaymentMethod(true);
        }}
      />

      <FormPaymentMethod
        active={activeFormPaymentMethod}
        handleNext={() => {
          setActiveFormPaymentMethod(false);
        }}
      />
    </CardMenu>
  );
};

const CartAndPayment = (props) => {
  const { activeStepThree } = useControlContext();

  return (
    <CardMenu
      active={activeStepThree}
      title="Confirmação & Pagamento"
      icon={faMoneyBill1Wave}
      badge="3º"
    >
      <Cart />
      <CardUpSell />
      <ProgressViewer />
      <Total />
    </CardMenu>
  );
};

const Pagamento = () => {
  const { invoice } = useInvoiceContext();
  const [isOffline, setIsOffline] = useState(false);
  const {
    pagseguro,
    sessionID,
    setSessionID,
    setPagSeguroDirectPaymentInstance,
    setPgReady,
  } = usePagSeguroContext();

  const { setBackEndVersion } = useControlContext();

  // pegar o sessionID do pagseguro
  useEffect(() => {
    const fetchPagSeguroID = async () => {
      console.log("fetchPagSeguroID");
      try {
        const response = await fetch(`${API_BASE_URL}/pagseguro`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message);
        }

        const data = await response.json();
        setSessionID(data.session_id);
      } catch (error) {
        console.error("Error ao pegar ID de sessão do PagSeguro: ", error);
        setIsOffline(true);
      }
    };

    if (!sessionID) {
      fetchPagSeguroID();
    }
  }, [sessionID, setSessionID]);

  // carregar o script do pagseguro
  useEffect(() => {
    const initPagSeguro = (pagSeguroDirectPayment) => {
      try {
        pagSeguroDirectPayment.setSessionId(sessionID);

        pagSeguroDirectPayment.getPaymentMethods({
          success: function (json) {
            setPgReady(true);
            console.log(json);
          },
          error: function (json) {
            var erro = "";
            var i;
            for (i in json.errors) {
              erro = erro + json.errors[i];
            }

            console.error("Error ao carregar o script do PagSeguro: ", erro);
          },
          complete: function (json) {},
        });

        setPagSeguroDirectPaymentInstance(pagSeguroDirectPayment);
      } catch (error) {
        console.error(
          "Error Critico ao carregar o script do PagSeguro: ",
          error,
        );
      }
    };

    if (sessionID !== "") {
      // Carregar o script e armazená-lo em uma variável acessível em todo o componente
      const script = document.createElement("script");
      script.src =
        "https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js";
      script.async = true;
      script.onload = () => {
        // A biblioteca foi carregada, você pode usá-la em todo o componente
        const pagSeguroDirectPayment = window.PagSeguroDirectPayment;
        initPagSeguro(pagSeguroDirectPayment); // Exemplo de função de inicialização
      };
      document.body.appendChild(script);
    }
  }, [sessionID, setPagSeguroDirectPaymentInstance, setPgReady]);

  // pegar a versão do backend
  useEffect(() => {
    const fetchBackEndVersion = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/status`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message);
        }

        const data = await response.json();
        setBackEndVersion(data.version);
      } catch (error) {
        console.error("Error ao pegar a versão do backend: ", error);
      }
    };

    fetchBackEndVersion();
  }, [setBackEndVersion]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ flex: "1" }}>
        <Header />
        <Container className="mt-3 mb-5">
          <Row {...(isOffline ? { hidden: true } : {})}>
            <Col lg={4} md={12} sm={12} className="mb-4">
              <CustomerRegister />
            </Col>

            <Col lg={4} md={12} sm={12} className="mb-4">
              <CustomerContactAndPayMode />
            </Col>

            <Col lg={4} md={12} sm={12} className="mb-4">
              <CartAndPayment />
            </Col>
          </Row>
          <Row {...(isOffline ? {} : { hidden: true })}>
            <Col lg={12} md={12} sm={12} className="mb-4 text-center ">
              <div className="display-4 mb-4 mt-5">
                <FontAwesomeIcon icon={faExclamationTriangle} color="#d9534f" />
                <strong className="fw-semibold ms-2">Ops...</strong>
              </div>
              <p className="text-muted fw-semibold fs-5">
                O servidor de pagamento está offline, portanto não será possível
                realizar o pagamento.
              </p>
              <p className="text-muted fw-semibold fs-5">
                Por favor, tente novamente mais tarde.
              </p>
            </Col>

            {/* REMOVER NO PRODUTO FINAL */}
            <Card border="default" className="mt-5 mb-5" hidden>
              <Card.Header>INVOICE</Card.Header>
              <Card.Body>
                <pre>{JSON.stringify({ invoice }, null, 2)}</pre>{" "}
              </Card.Body>
            </Card>

            <Card border="default" className="mt-5 mb-5" hidden>
              <Card.Header>PagSeguro</Card.Header>
              <Card.Body>
                <pre>{JSON.stringify({ pagseguro }, null, 2)}</pre>
              </Card.Body>
            </Card>
            {/* REMOVER NO PRODUTO FINAL */}
          </Row>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default Pagamento;
